import { render, staticRenderFns } from "./PrintScreen.vue?vue&type=template&id=589751e4&scoped=true"
import script from "./PrintScreen.vue?vue&type=script&lang=js"
export * from "./PrintScreen.vue?vue&type=script&lang=js"
import style0 from "./PrintScreen.vue?vue&type=style&index=0&id=589751e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589751e4",
  null
  
)

export default component.exports